import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent implements OnInit {

  constructor() { }
  showQuestionnaire : boolean = false;
  disponibiliter : string;
  Apparence : string;
  amabilite : string;

  rapidite : string;
  qualite : string;
  arrangement : string;
  respectDelaisLivraison : string;

  diversiteProduit : string;
  qualiteProduit : string;
  nouveauteProduit : string;

  diversiteEmballage : string;
  qualiteEmballage : string;
  designEmballage : string;

  disponibiliteCaissier : string;
  amabiliteCaissier : string;
  rapiditeService : string;
  
  remarquesSuggestions : string;
  nomPrenom : string;
  ngOnInit(): void {
  }
  commencer()
  {
    this.showQuestionnaire = true
  }
}
